import { inject as _, getCurrentInstance as c } from "vue";
function g() {
  let e = window.__currentNode;
  return e || (e = Symbol("__currentNode"), window.__currentNode = e), e;
}
function f() {
  const e = g();
  return _(
    e,
    () => ({
      mode: "live",
      node: null,
      isDesignerEnv: !1
    }),
    !0
  );
}
function l() {
  let e = window.__rendererContext;
  return e || (e = Symbol("__rendererContext"), window.__rendererContext = e), e;
}
function m() {
  const e = l();
  return _(
    e,
    () => {
      var d, t, r;
      const n = (r = (t = (d = c()) == null ? void 0 : d.proxy) == null ? void 0 : t.$props) != null ? r : {};
      return {
        components: o(n, "components", {}),
        rerender: o(n, "rerender", {}),
        designMode: o(n, "designMode", "live"),
        getNode: o(n, "getNode", () => null),
        triggerCompGetCtx: o(
          n,
          "triggerCompGetCtx",
          () => {
          }
        )
      };
    },
    !0
  );
}
function o(e, n, d) {
  var t, r, u, i;
  return e[n] || e[`__${n}`] || ((r = (t = e == null ? void 0 : e.scope) == null ? void 0 : t._props) == null ? void 0 : r[n]) || ((i = (u = e == null ? void 0 : e.scope) == null ? void 0 : u._props) == null ? void 0 : i[`__${n}`]) || d;
}
export {
  g as getCurrentNodeKey,
  l as getRendererContextKey,
  f as useCurrentNode,
  m as useRendererContext
};
